module.exports = __webpack_public_path__ + "static/media/sort-desc.853dc6fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sort-desc.svg
// module id = 8
// module chunks = 1